
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"38","height":"38","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"19","cy":"19","r":"17","stroke":"#CD9E64","stroke-width":"4"}}),_c('path',{attrs:{"d":"M11 18.931L17.044 25 28 14","stroke":"#CD9E64","stroke-width":"4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    